/**
 * PATH: packages/job-hub/src/jobs/qa/archivedStructureTemplates.ts
 * FILE_ID: JOBHUB-QA-ARCHIVED-TEMPLATES-001
 * PURPOSE: Floor and area cards that used to live only in the QA hub wizard.
 * WHY: The same cards must add structure to a QA that is already open.
 */
export interface QuickTemplate {
  id: string
  name: string
  category: 'residential' | 'commercial' | 'infrastructure'
  projectType: 'new_construction' | 'renovation' | 'remediation'
  buildingClasses: string[]
  trades: string[]
  floors: { name: string; areas: string[] }[]
}

export interface FloorTemplate {
  name: string
  areas: string[]
}

export const QUICK_TEMPLATES: QuickTemplate[] = [
  {
    id: 'residential-new', name: 'New Home Inspection', category: 'residential',
    projectType: 'new_construction', buildingClasses: ['Class 1a'],
    trades: ['Structural', 'Electrical', 'Plumbing'],
    floors: [
      { name: 'Ground Floor', areas: ['Living', 'Kitchen', 'Garage'] },
      { name: 'First Floor', areas: ['Master Bedroom', 'Bedroom 2', 'Bathroom'] },
    ],
  },
  {
    id: 'commercial-fitout', name: 'Commercial Fit-out', category: 'commercial',
    projectType: 'renovation', buildingClasses: ['Class 5', 'Class 6'],
    trades: ['Electrical', 'HVAC', 'Fire Safety', 'Interior Fit-out'],
    floors: [{ name: 'Main Floor', areas: ['Reception', 'Open Plan', 'Amenities'] }],
  },
  {
    id: 'apartment-new', name: 'Apartment Block', category: 'residential',
    projectType: 'new_construction', buildingClasses: ['Class 2'],
    trades: ['Structural', 'Electrical', 'Plumbing', 'Fire Safety', 'Waterproofing'],
    floors: [],
  },
  {
    id: 'warehouse', name: 'Warehouse/Industrial', category: 'commercial',
    projectType: 'new_construction', buildingClasses: ['Class 7b', 'Class 8'],
    trades: ['Structural', 'Electrical', 'Fire Safety'],
    floors: [{ name: 'Main Floor', areas: ['Loading Bay', 'Storage Area', 'Office'] }],
  },
]

export function archivedAreaNames(template: QuickTemplate): string[] {
  const names = template.floors.flatMap((floor) => floor.areas.map((area) => `${floor.name} - ${area}`))
  return names.length > 0 ? names : [template.name]
}

export async function addArchivedStructure(
  addTable: (inspectionId: string, name?: string, seedDefaultItems?: boolean) => Promise<unknown>,
  inspectionId: string,
  template: QuickTemplate,
): Promise<string[]> {
  const names = archivedAreaNames(template)
  for (const name of names) {
    // Reused from: packages/job-hub/src/jobs/tabs/job-qa/phone/QaPhoneSheetHost.tsx (onAdd -> addTable)
    await addTable(inspectionId, name, false)
  }
  return names
}
